import React from 'react'
import styled from 'styled-components'

const Main = ({ modifier, children }) => {
  return (
    <Wrapper className={`main ${modifier ? modifier : ``}`}>
      <Container>{children}</Container>
    </Wrapper>
  )
}

const Wrapper = styled.main`
  width: 100%;
  max-width: 100vw;
  position: relative;
  margin-top: var(--header-height);

  h1 {
    [color-scheme='wwf'] & {
      color: var(--color-primary);
    }

    [color-scheme='nwa'] & {
      color: var(--color-secondary);
    }

    [color-scheme='wcw'] & {
      color: var(--color-text2);
    }
  }
`

const Container = styled.div`
  width: 100%;
  height: 100%;
  margin: 0 auto;
`

export default Main
